import api from './index'

export default function getFeatureStatus(featureName) {
  return api.post(`/api/feature-status`, { featureName })
}
